import { proxy } from 'valtio';

import { IntercomChannel } from 'models';

const intercomState = proxy({
    opened: false,
    activeChannel: null as IntercomChannel['id'] | null,
});

export { intercomState };
